import { Text } from '@rbilabs/universal-components';

import Link from 'components/link';

export const DeliveryTermsText = Text.withConfig({
  fontSize: 'md',
  textAlign: 'center',
});

export const TermsLink = Link.withConfig({
  fontSize: 'md',
  isUnderlined: true,
});
